import React from 'react';
import axios from 'axios';
import { 
  Table, 
  Input, 
  Button, 
  Popover, 
  message, 
  Avatar 
} from 'antd';
import Highlighter from 'react-highlight-words';
import { 
  SearchOutlined, 
  FundViewOutlined, 
  UserOutlined, 
  DownloadOutlined 
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../../serverconn';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import ProfessionalLayout from '../../../components/ProfessionalLayout';
import BusinessIcon from '@mui/icons-material/Business';
import AgentRights from '../components/AgentRights';

const CryptoJS = require("crypto-js");

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let bizuserid = '';
let token = '';

class Hub_AgentsList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    delivery_agents: [],
    datarequested: true,
    userrights: {}
  };

  componentDidMount() {
    this.initializeAuth();
    this.componentmountactions();
  }

  initializeAuth = () => {
    if (localStorage.getItem("bizuserid")) {
      bizuserid = CryptoJS.AES.decrypt(localStorage.getItem("bizuserid"), 'my-secret-key@1234').toString(CryptoJS.enc.Utf8);
    }
    
    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    };
  }

  componentmountactions = () => {
    const hubId = localStorage.getItem("coodinated_hub");
    
    axios.get(`${serverconfig.backendserverurl}/api/delivery_agents/?collection_hub=${hubId}`)
      .then(res => {
        this.setState({
          delivery_agents: res.data
        });
      })
      .catch(error => console.error('Error loading hub agents:', error));

    axios.get(`${serverconfig.backendserverurl}/api/accountrights/?user=${bizuserid}`)
      .then(res => {
        this.setState({
          userrights: res.data[0],
          datarequested: false
        });
      })
      .catch(error => {
        console.error('Error loading user rights:', error);
        this.setState({ datarequested: false });
      });
  }

  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/delivery_agents/${id}`)
      .then(res => {
        message.success("Agent deleted successfully");
        this.componentmountactions();
      })
      .catch(error => {
        console.error('Error deleting agent:', error);
        message.error("Failed to delete agent");
      });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const { delivery_agents, datarequested } = this.state;
    const hubName = localStorage.getItem("hub_name") || "Current Hub";

    const columns = [
      {
        title: 'Profile',
        dataIndex: 'profile_pic',
        key: 'profile_pic',
        render: (text, record) => 
          <Avatar
            size={60}
            icon={<UserOutlined />}
            alt="User Pic"
            src={`${serverconfig.backendserverurl}/customqueries/getfile/${Number(record.id)}/user_account`}
          />,
      },
      {
        title: 'Names',
        dataIndex: 'FullName',
        key: 'id',
        ...this.getColumnSearchProps('FullName'),
      },
      {
        title: 'Agent code',
        dataIndex: 'agent_code',
        key: 'id',
        ...this.getColumnSearchProps('agent_code'),
      },
      {
        title: 'Phone contact',
        dataIndex: 'RegisteredPhoneNumber1',
        key: 'id',
      },
      {
        title: 'ID',
        dataIndex: 'IDNumber',
        key: 'id',
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'id',
        render: (text, record) => (
          <div style={{ display: 'flex', gap: 8 }}>
            <Popover content="View and edit agent details" title="Agent Details">
              <Link to={`/deliveryagents/${text}`}>
                <FundViewOutlined style={{ color: '#1890ff', fontSize: 16 }} />
              </Link>
            </Popover>
            <AgentRights agentId={record.id} agentName={record.FullName} />
          </div>
        ),
      },
    ];

    const headerActions = (
      <div style={{ display: 'flex', gap: 12 }}>
        <ExcelFile 
          filename={`${hubName}-Agents`} 
          element={
            <Button 
              type="primary" 
              icon={<DownloadOutlined />}
              className="professional-button professional-button-primary"
            >
              Export Excel
            </Button>
          }
        >
          <ExcelSheet data={delivery_agents} name="delivery_agents bio">
            <ExcelColumn label="Name" value="FullName"/>
            <ExcelColumn label="Tel" value="RegisteredPhoneNumber1"/>
            <ExcelColumn label="ID number" value="IDNumber"/>
            <ExcelColumn label="Agent code" value="agent_code"/>
          </ExcelSheet>
        </ExcelFile>
      </div>
    );

    return (
      <ProfessionalLayout
        title={`${hubName} - Agents Management`}
        subtitle={`Manage ${delivery_agents.length} agents assigned to this hub`}
        icon={<BusinessIcon />}
        headerActions={headerActions}
        loading={datarequested}
      >
        {!datarequested && (
          <div className="professional-content">
            <Table
              scroll={{ x: 1000 }}
              columns={columns}
              pagination={{
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal: (total, range) => 
                  `${range[0]}-${range[1]} of ${total} agents`
              }}
              dataSource={delivery_agents}
              bordered
              size="middle"
            />
          </div>
        )}
      </ProfessionalLayout>
    );
  }
}

export default Hub_AgentsList; 
